import { ApiService } from "./api.service";
export default class RecurringBillingService extends ApiService {
  namespace = "recurringBilling";
  icon = "ReCurring";
  name = "Notes";
  favicon = "Repeat";
  action = "action";
  Width = 900;
  label = "good";
  constructor() {
    super("recurring-billing");
  }
}
